import React from "react";
import "../../styles/homeSections.css";

/**
 * Skeleton component displaying 4 shimmering cards during configuration load.
 */
const HomeSectionsSkeleton = () => {
  // Render exactly 4 cards to match the desktop layout
  const skeletonArray = Array.from({ length: 4 });

  return (
    <div className="sections-grid">
      {skeletonArray.map((_, idx) => (
        <div key={idx} className="section-card skeleton-card">
          {/* Top-left icon circle skeleton */}
          <div className="skeleton-icon skeleton-shimmer" />

          {/* Centered image container skeleton */}
          <div className="section-card-image-wrapper">
            <div className="skeleton-image skeleton-shimmer" />
          </div>

          {/* Details skeleton */}
          <div className="section-card-info">
            <div className="skeleton-title skeleton-shimmer" />
            <div className="skeleton-desc skeleton-shimmer" />
            <div className="skeleton-desc short skeleton-shimmer" />
            <div className="skeleton-cta skeleton-shimmer" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default HomeSectionsSkeleton;
